// FIX BODY

export function fix_body_to_actual_y_position() {
    document.body.classList.add('no_scroll');

    var scrollY = `${window.scrollY}px`;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}`;
}

export function unfix_body() {
    document.body.classList.remove('no_scroll');

    var scrollY = parseInt(document.body.style.top, 10) * -1;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
}

// Make available globally for legacy code
window.fix_body_to_actual_y_position = fix_body_to_actual_y_position;
window.unfix_body = unfix_body;
